import getEnv from "./getEnv";
import { Modal, message } from "antd";
import intl from "react-intl-universal";
import getUrlParams from "./getUrlParams";

const searchParam = (obj) => {
  const result = [];

  const traverse = (currentObj, orObjKey) => {
    for (const key in currentObj) {
      if (currentObj[key] && typeof currentObj[key] === "object") {
        if (Array.isArray(currentObj[key])) {
          currentObj[key].forEach((item) => traverse(item, key));
        } else {
          traverse(currentObj[key], key);
        }
      } else if (key === "type" && currentObj[key]) {
        const { key: objKey, type, min, max, value } = currentObj;
        if (type === "NUMBER_RANGE" && min && max) {
          result.push({
            key: orObjKey,
            value: `${objKey}:${min}-${max}`,
            otherKey: currentObj?.otherKey,
          });
        } else if (type === "SINGLE_SELECT" && value) {
          result.push({ key: orObjKey, value: `${objKey}:${value}` });
        } else if (type === "CHECKBOX" && value) {
          result.push({ key: orObjKey, value: `${objKey}` });
        } else if (
          type === "MULTIPLE_SELECT" &&
          value &&
          value.length &&
          Array.isArray(value)
        ) {
          result.push({
            key: orObjKey,
            value: `${objKey}:${value[0]}${
              value.length > 1 ? ` and ${value.length - 1} more` : ""
            }`,
          });
        } else if (
          type === "CASCADE_SELECT" &&
          (currentObj.children || []).length > 0
        ) {
          result.push({
            key: orObjKey,
            value: `${objKey}:${currentObj.children[0].name}${
              currentObj.children.length > 1
                ? ` and ${currentObj.children.length} more`
                : ""
            }`,
          });
        }
      }
    }
  };

  traverse(obj, "");
  return result;
};

const processData = (arr, keyname) => {
  const result = [];

  arr.forEach((item) => {
    const firstItem = item[0];
    const secondItem = item[1] || null;

    // 判断是否有子项（是否有完整的数据）
    if (firstItem && secondItem) {
      // 有子项，处理为完整的结构
      const existingCategory = result.find(
        (cat) => cat.value === firstItem.name,
      );

      if (!existingCategory) {
        result.push({
          key: keyname,
          value: firstItem.id,
          name: firstItem.name,
          children: [
            {
              key: firstItem.name,
              value: secondItem.id,
              name: secondItem.name,
              children: [],
              type: "CASCADE_SELECT",
            },
          ],
        });
      } else {
        existingCategory.children.push({
          key: firstItem.name,
          value: secondItem.id,
          name: secondItem.name,
          children: [],
          type: "CASCADE_SELECT",
        });
      }
    } else {
      const newCategory = {
        key: keyname,
        value: firstItem.id,
        type: "CASCADE_SELECT",
        children: firstItem.children.map((child) => ({
          key: firstItem.name,
          value: child.id,
          name: child.name,
          children: [],
          type: "CASCADE_SELECT",
        })),
      };
      result.push(newCategory);
    }
  });

  return result;
};

const merchantSearchParam = (obj) => {
  return {
    searchCount: obj?.searchCount,
    filterDay: obj?.filterDay,
    searchParam: {
      creators: {
        productCategory: obj?.productCategory,
        followerCount: {
          key: "Follower count",
          min: obj?.min,
          max: obj?.max,
          type: "NUMBER_RANGE",
          otherKey: ["min", "max"],
        },
        avgCommissionRate: {
          key: "Avg. commission rate",
          value: obj?.avgCommissionRate,
          type: "SINGLE_SELECT",
        },
        contentType: {
          key: "Content type",
          value: obj?.contentType,
          type: "SINGLE_SELECT",
        },
        creatorAgency: {
          key: "Creator agency",
          value: obj?.creatorAgency,
          type: "SINGLE_SELECT",
        },
        fastGrowing: {
          key: "Fast growing",
          value: obj?.fastGrowing,
          type: "CHECKBOX",
        },
        noInvitedInPast90Days: {
          key: "Not invited in past 90 days",
          value: obj?.noInvitedInPast90Days,
          type: "CHECKBOX",
        },
        isInFlatFeeWhiteList: {
          key: "is_in_flat_fee_whitelist",
          value: obj?.isInFlatFeeWhiteList,
          type: "CHECKBOX",
        },
      },
      followers: {
        followerAge: {
          key: "Follower age",
          value: obj?.followerAge,
          type: "MULTIPLE_SELECT",
        },
        followerGender: {
          key: "Follower gender",
          value: obj?.followerGender,
          type: "SINGLE_SELECT",
        },
      },
      performance: {
        gmv: {
          key: "GMV",
          value: obj?.gmv,
          type: "MULTIPLE_SELECT",
        },
        itemsSold: {
          key: "Items sold",
          value: obj?.itemsSold,
          type: "MULTIPLE_SELECT",
        },
        avgViewsPerVideo: {
          key: "Average views per video",
          value: obj?.avgViewsPerVideo,
          type: "SINGLE_SELECT",
        },
        avgViewsPerVideoFilterByShoppable: {
          key: "Average views per video Filter by shoppable",
          value: obj?.avgViewsPerVideoFilterByShoppable,
          type: "CHECKBOX",
        },
        avgViewerPerLive: {
          key: "Average viewers per LIVE",
          value: obj?.avgViewerPerLive,
          type: "SINGLE_SELECT",
        },
        avgViewerPerLiveFilterByShoppableLiveVideos: {
          key: "Average viewers per LIVE Filter by shoppable LIVE",
          value: obj?.avgViewerPerLiveFilterByShoppableLiveVideos,
          type: "CHECKBOX",
        },
        engagementRate: {
          key: "Engagement rate",
          value: obj?.engagementRate,
          type: "SINGLE_SELECT",
        },
        engagementRateFilterByShoppableVideos: {
          key: "Engagement rate Filter by shoppable",
          value: obj?.engagementRateFilterByShoppableVideos,
          type: "CHECKBOX",
        },
        estPostRate: {
          key: "Est. post rate",
          value: obj?.estPostRate,
          type: "SINGLE_SELECT",
        },
        brandCollaborations: {
          key: "Brand collaborations",
          value: obj?.brandCollaborations,
          type: "MULTIPLE_SELECT",
        },
      },
      share: {
        gmv: {
          key: "gmv",
          min: obj?.medGmvRevenueMin,
          max: obj?.medGmvRevenueMax,
          type: "NUMBER_RANGE",
          otherKey: ["medGmvRevenueMin", "medGmvRevenueMax"],
        },
        productCategoryList: {
          key: "product Category",
          value: obj?.productCategoryList,
          type: "MULTIPLE_SELECT",
        },
        followerCount: {
          key: "Follower count",
          min: obj?.quickMin,
          max: obj?.quickMax,
          type: "NUMBER_RANGE",
          otherKey: ["quickMin", "quickMax"],
        },
        quickFollowerAge: {
          key: "Follower age",
          value: obj?.quickFollowerAge,
          type: "MULTIPLE_SELECT",
        },
        quickFollowerGender: {
          key: "Follower gender",
          value: obj?.quickFollowerGender,
          type: "SINGLE_SELECT",
        },
        quickContentType: {
          key: "Content type",
          value: obj?.quickContentType,
          type: "SINGLE_SELECT",
        },
        quickIsInFlatFeeWhiteList: {
          key: "is_in_flat_fee_whitelist",
          value: obj?.quickIsInFlatFeeWhiteList,
          type: "CHECKBOX",
        },
        quickFastGrowing: {
          key: "Fast growing",
          value: obj?.quickFastGrowing,
          type: "CHECKBOX",
        },
        invitedBefore90d: {
          key: "has_invited_before_90d",
          value: obj?.invitedBefore90d,
          type: "CHECKBOX",
        },
      },
    },
  };
};

const authCheck = (arr, key) => {
  const findIndex = (arr || []).findIndex((item) => {
    return item === key;
  });
  if (findIndex !== -1) {
    return true;
  }
  Modal.confirm({
    title: intl.get("common_http_title"),
    content: intl.get("common_http_403_desc"),
    keyboard: false,
    centered: true,
    cancelText: intl.get("common_http_cancle"),
    maskClosable: true,
    onOk: () => {
      window.location.href = "/package";
    },
    onCancel: () => {
      Modal.destroyAll();
    },
  });
  return false;
};

const loginPlugin = (openPlhgin = false, noJudgmentPluginLogin = false) => {
  // judgmentPluginLogin 判断插件登录状态， 不再判断插件安装状态， 不再唤起
  console.log(openPlhgin, noJudgmentPluginLogin);
  return true;
  // 美区不用插件

  // if (!noJudgmentPluginLogin) {
  //   const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
  //   if (userInfo?.loginRecord?.isOnline) {
  //     return true;
  //   }
  //   message.error(intl.get("login_plugin_error"));
  //   return false;
  // }
  // if (document.getElementById(getEnv() === "prod" ? "95ai" : "95ai-test")) {
  //   if (openPlhgin) {
  //     window.postMessage(
  //       {
  //         type:
  //           getEnv() === "prod"
  //             ? "trigger95aiPlugin"
  //             : "trigger95aiPlugin-test",
  //         action: "openPopup",
  //         reason: "user_action", // 或 'auto_trigger'
  //         pageInfo: {
  //           url: window.location.href,
  //           title: document.title,
  //           timestamp: Date.now(),
  //         },
  //       },
  //       "*"
  //     );
  //   }

  //   return true;
  // } else {
  //   // 未安装插件 或 插件版本过低
  //   message.error(intl.get("install_plugin_error"));
  //   return false;
  // }
};

const parseDateSafe = (input: string | number | Date): Date => {
  if (input instanceof Date) return input;
  if (typeof input === "number") return new Date(input);

  // 如果是字符串
  let str = input.trim();

  // 如果没有时区信息，尝试补全（假设是本地时间）
  if (!/Z$/.test(str) && !/[+-]\d{2}:?\d{2}$/.test(str)) {
    // 方案 A：当作 UTC（加 Z）
    // str += 'Z';

    // 方案 B：当作本地时间 → 用构造函数解析（推荐）
    const [datePart, timePart = "00:00:00"] = str.split(/[T\s]/);
    const [y, m, d] = datePart.split("-").map(Number);
    const [H, M, S = 0] = timePart.split(":").map(Number);
    return new Date(y, m - 1, d, H, M, S);
  }

  // 否则直接用原字符串（带时区）
  return new Date(str);
};

export {
  getEnv,
  getUrlParams,
  searchParam,
  processData,
  merchantSearchParam,
  authCheck,
  loginPlugin,
  parseDateSafe,
};
